import { useState, useMemo, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Grid2X2, Bot, type LucideIcon } from "lucide-react";
import { toolDefinitions } from "../features/tools/registry";
export interface NavigationItem {
  id: string;
  label: string;
  icon: LucideIcon;
  path: string;
  children?: NavigationItem[];
  roles?: string[];
  badge?: string | number;
}
export const navigationItems: NavigationItem[] = [
  { id: "dashboard", label: "Home", icon: Home, path: "/dashboard" },
  ...toolDefinitions.map((t) => ({
    id: t.id,
    label: t.label,
    icon: t.icon,
    path: t.path,
    roles: t.allowedRoles,
  })),
  { id: "tools", label: "All tools", icon: Grid2X2, path: "/tools" },
  { id: "agent", label: "Agent", icon: Bot, path: "/agent" },
];
export function useNavigation() {
  const location = useLocation(),
    navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const activeItem = useMemo(
    () =>
      navigationItems.find(
        (item) =>
          location.pathname === item.path ||
          location.pathname.startsWith(item.path + "/"),
      ) || null,
    [location.pathname],
  );
  const breadcrumbs = useMemo(
    () => [
      { label: "Home", path: "/dashboard" },
      ...(activeItem && activeItem.id !== "dashboard"
        ? [{ label: activeItem.label, path: activeItem.path }]
        : []),
    ],
    [activeItem],
  );
  const navigateTo = useCallback((path: string) => navigate(path), [navigate]);
  return {
    isCollapsed,
    setIsCollapsed,
    activeRoute: location.pathname,
    activeItem,
    breadcrumbs,
    navigationItems,
    navigateTo,
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
  };
}
export default useNavigation;
